export default __webpack_public_path__ + "static/media/report4.64e190f2.svg";